// @flow

import React, {useRef, useEffect} from 'react';

import {MouseMoveObserver} from './utils';
import {MouseObserverProvider} from './contexts';

import type {Node, ComponentType} from 'react';

import type {ObserverConfig} from './typedef';


type Props = {|
    children: Node,
    containerId: string,
    observerConfig?: ObserverConfig,
|};

export const ContainerMouseObserver: ComponentType<Props> = (props: Props) => {
    const {
        children,
        containerId,
        observerConfig
    } = props;

    const ref = useRef<HTMLElement | null>(null);
    const instanceObserver = useRef<MouseMoveObserver>(new MouseMoveObserver(observerConfig));

    useEffect(() => {
        const element = ref.current;
        const observer = instanceObserver.current;

        if (element) {
            observer.init(element);

            return () => {
                observer.destroy(element);
            };
        }

        return undefined;
    }, []);

    return (
        <MouseObserverProvider subscribe={instanceObserver.current.subscribe}>
            <div ref={ref} id={containerId}>
                {children}
            </div>
        </MouseObserverProvider>
    );
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");

require("./utils");
